import { resolveIdentityConfig } from 'Common/auth/identityConfig'
import { getEnvironment, servicesAsync } from 'Common/environment/environment'
import { fetchGet, fetchPost } from 'Common/utils/query/request'

const baseUrl = servicesAsync.users('/v1/users/currentuser/settings')

const useSid = async () => resolveIdentityConfig(await getEnvironment()).mode === 'sid'
const sidSettingsApi = () => import('Common/api/SettingsApi.sid')

export type UserSettings = Record<string, string>

export interface GridState {
    key: string
    value: string
}

export interface GridStateNamed {
    name: string
    key: string
    state: string
}

export const gridStateGet = async (key: string) => {
    if (await useSid()) return (await sidSettingsApi()).gridStateGet(key)
    return await fetchGet(`${await baseUrl}/${key}`)
}

export const gridStatePost = async (request: GridState) => {
    if (await useSid()) return (await sidSettingsApi()).gridStatePost(request)
    return await fetchPost(`${await baseUrl}`, JSON.stringify({ [request.key]: request.value }))
}

export const userSettingsGet = async () => {
    if (await useSid()) return (await sidSettingsApi()).userSettingsGet()
    return await fetchGet(`${await baseUrl}`)
}
